/**
 * FNV-1a, 32-bit, hex. One definition, because two things now key on it and a
 * second copy would be two identities that agree until somebody edits one.
 *
 * Not a cryptographic hash and does not need to be. Both callers compare a
 * thing against its own previous self — a plan against the plan it was, a
 * graded room against the room already filed — so the only property that
 * matters is that it is a pure function of the string handed in and stable
 * across reloads. No Date, no Math.random.
 *
 * It lives here rather than in planFingerprint.js so that reaching for the hash
 * does not drag usePlanState (and the hook chain behind it) into a module that
 * has nothing to do with the plan surface.
 */
export function hashString(str) {
  let h = 0x811c9dc5;
  for (let i = 0; i < str.length; i++) {
    h ^= str.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h.toString(16).padStart(8, "0");
}
